import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Spin } from "antd";
import moment from "moment";
import { useHistory } from "react-router-dom";

import Questions from "../../components/form/question/questions";
import MainVotingInfo from "../../components/form/main-voting-info/main-voting-info";
import FormButtons from "../../components/form/form-buttons/form-buttons";

import useSavedValuesFromSessionsStorage from "../../hooks/useSavedValuesFormSessionStorage";
import saveVoting from "../../store/thunks/save-voting";
import { startVoting } from "../../store/thunks/voting-states";

import "./new-voting.scss";
import { mergeDeep } from "../../../../helpers/merge-deep";

const Voting = (props) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const itemLoading = useSelector((store) => store.votingStore.itemLoading);
	const { form, height, allValues } = props;
	const {
		resetFields,
		validateFields,
		setFieldsValue,
		getFieldDecorator,
	} = form;

	const styleContainer = {
		height: height,
		overflowY: "auto",
		overflowX: "hidden",
		textAlign: "center",
		alignItems: "center",
		borderRight: "1px solid",
		borderColor: "#efefef",
	};
	const memoizedForm = useMemo(() => props.form, []);

	useSavedValuesFromSessionsStorage(setFieldsValue, getFieldDecorator);
	useEffect(() => {
		sessionStorage.setItem(
			"new-voting",
			JSON.stringify({ ...allValues, timestamp: moment() })
		);
	}, [allValues]);
	const onPlay = () => {
		validateFields(async (errors, values) => {
			if (!errors) {
				try {
					const id = await dispatch(saveVoting(values));
					await dispatch(startVoting({ ...values, id }));
					sessionStorage.removeItem("new-voting");
					history.push(`/Voting/${id}`);
				} catch (e) {
					console.error(e);
				}
			}
		});
	};
	const onSave = () => {
		validateFields(async (errors, values) => {
			if (!errors) {
				try {
					const id = await dispatch(saveVoting(values));
					sessionStorage.removeItem("new-voting");
					history.push(`/Voting/${id}`);
				} catch (e) {
					console.error(e);
				}
			}
		});
	};

	const onDelete = () => {
		resetFields();
		sessionStorage.removeItem("new-voting");
		history.push(`/Voting`);
	};

	const buttonsProps = {
		formValues: allValues,
		onPlay,
		onSave,
		onDelete,
		withTimeout: true,
	};

	return (
		<div style={styleContainer} className="NewVoting">
			<Spin
				style={{ minHeight: 500 }}
				size="large"
				spinning={itemLoading}
				tip="Загрузка..."
				delay={100}
			>
				<FormButtons {...buttonsProps} />
				<Form layout="vertical">
					<MainVotingInfo
						form={memoizedForm}
						title={allValues.title}
						description={allValues.description}
						period={allValues.period}
						file={allValues.file}
						addresses={allValues.addresses}
					/>
					<Questions
						form={memoizedForm}
						questions={allValues.questions}
						questionsKeys={allValues.questionsKeys}
					/>
				</Form>
				<FormButtons bottom {...buttonsProps} />
			</Spin>
		</div>
	);
};

const VotingForm = (props) => {
	const [allValues, setAllValues] = useState({});
	const FormComponent = useMemo(
		() =>
			Form.create({
				onValuesChange: (_props, changedValues, newAllValues) => {
					const ableToMerge = !Object.keys(changedValues).some(
						(key) => key.includes(".") || key.includes("[")
					);
					setAllValues((allValues) => {
						if (ableToMerge) {
							return mergeDeep(allValues, changedValues, {
								ignoreKeys: ["file"],
							});
						} else {
							return { ...newAllValues };
						}
					});
				},
			})(Voting),
		[]
	);
	return <FormComponent {...props} allValues={allValues} />;
};

export default VotingForm;
